import Work1 from "../../assets/work1.jpg";
import Work2 from "../../assets/work2.jpg";
import Work3 from "../../assets/work3.jpg";
import Work4 from "../../assets/work4.jpg";
import Work5 from "../../assets/work5.jpg";
import Work6 from "../../assets/work6.jpg";
import Work7 from "../../assets/work7.jpg";
import Work8 from "../../assets/work8.jpg";
import Work9 from "../../assets/work9.jpg";

export const projectsData = [
  {
    id: 1,
    image: Work1,
    title: "First Bootstrap Portfolio 2022",
    category: "web/apps",
    link: "https://i467618.hera.fontysict.net/portfolio2022/index.html", // Add your custom link here
  },
  {
    id: 2,
    image: Work2,
    title: "Case Study",
    category: "research",
    link: "https://docs.google.com/document/d/1I1PqCdAbJSGuNguxddTxnnu1pfYaHqB1PcCvIf5b2jM/edit?usp=sharing", // Add your custom link here
  },
  {
    id: 3,
    image: Work5,
    title: "Brand design (Photoshop)",
    category: "design",
    link: "https://i467618.hera.fontysict.net/static/media/work5.ecc1c588054f37ef76eb.jpg", // Add your custom link here
  },
  {
    id: 4,
    image: Work4,
    title: "McHome PWA Mobile App",
    category: "web/apps",
    link: "https://youtu.be/QpEAgObyrnU", // Add your custom link here
  },
  {
    id: 5,
    image: Work6,
    title: "Civilink Kotlin App Showcase",
    category: "web/apps",
    link: "https://www.youtube.com/watch?v=Q6KinmCx7n0", // Add your custom link here
  },
  {
    id: 6,
    image: Work3,
    title: "Team Brand Design (Photoshop)",
    category: "design",
    link: "https://docs.google.com/document/d/1khIHtzQXf6SU5jnP41Av1bJgTZ8SSvhAzuQ6Cject9E/edit?usp=sharing", // Add your custom link here
  },
  {
    id: 7,
    image: Work7,
    title: "Photography Portfolio (InDesign)",
    category: "design",
    link: "https://i467618.hera.fontysict.net/portfolio2022/photography.pdf", // Add your custom link here
  },
  {
    id: 8,
    image: Work8,
    title: "McDonald's Ad (Premiere Pro)",
    category: "videos",
    link: "https://www.youtube.com/watch?v=_aFCdFl39p4", // Add your custom link here
  },
  {
    id: 9,
    image: Work9,
    title: "Personal Project (Premiere Pro)",
    category: "videos",
    link: "https://www.youtube.com/watch?v=Fvw3lyaHbRY", // Add your custom link here
  },
];

export const projectsNav = [
  {
      name: 'all',
  },
  {
      name: 'web/apps',
  },
  {
      name: 'research',
  },
  {
      name: 'design',
  },
  {
      name: 'videos',
  },
];
